import "./index.less"

import {COUNTRY_LANG} from "../../utils/staticData"
import { cookie, groupParamsByKey, getRunningTime} from '../../utils/index'

import { isElementInViewport, isElementOutOfViewport } from '../../utils/common-global-utils';
import {RenderEmptyBlockBox} from "../../snippets/empty-block-box";

function initUtils() {
    window.Jackery = {};
    window.getRunningTime = getRunningTime;
    window.Jackery.Utils = {
        isElementInViewport,
        isElementOutOfViewport
    };

    if (window.Shopify && window.Shopify.designMode) {
        // 编辑环境模式
        document.querySelector('body').classList.add('shopify-edit-mode');
    } else {
        // 仅预览或发布页模式下执行 公共空盒子版块渲染
        RenderEmptyBlockBox();
    }
}

/*
  设置全局utils - window.utils
  设置全局config - window.pageInfo
  判断account登录状态
*/
(function () {
    window.utils = window.utils ? window.utils : {}
    window.utils.cookie = cookie

    window.pageInfo = window.pageInfo ? window.pageInfo : {}
    cookie.set("_jk_lang", COUNTRY_LANG.get(window.pageInfo.cr))
    cookie.set("_jk_cr", window.pageInfo.cr)

    if(groupParamsByKey()['jackery_token']) { // 保存jackerytoken
        let jackeryToken = groupParamsByKey()['jackery_token'];
        cookie.set("_jk_user", encodeURIComponent(jackeryToken));

        let _params = new URLSearchParams(window.location.search);
        _params.delete("jackery_token");
        var newUrl = window.location.origin + window.location.pathname + "?" + _params.toString();

        window.history.pushState({ path: newUrl }, "", newUrl)

        // 从 checkout 页返回，强制刷新页面
        window.addEventListener('popstate', function (event) {
            if (event.state && event.state.path) {
                const previousPage = event.state.path;
                if (previousPage.includes('checkouts')) {
                    window.location.href = newUrl
                }
            }
        })
    }

    initUtils();
})()


// FIX: 苹果测试手机12 pro max日站点击加购，没有跳到购物车，有时加购会回到当前页，再点击加购提示错误
if(location.pathname === "/cart") {
    sessionStorage.setItem('__product_url', location.pathname);
}
if(location.pathname.startsWith("/products")) {
    const _k = sessionStorage.getItem('__product_url');
    sessionStorage.removeItem('__product_url');
    if(_k) {
        location.reload()
    }
}
// FIX: 苹果测试手机12 pro max日站点击加购，没有跳到购物车，有时加购会回到当前页，再点击加购提示错误


// TODO: 待迁移整理：全局函数处理
window.$(document).ready(function() {
    $('.rte table').wrap('<div class="table-wrapper"></div>');

    $(".cal_scroll_target").length > 0 && $(window).scroll(() => {
        if(document.querySelector("jky-header")) {
            const target_top = $(".cal_scroll_target").offset().top
            var scrolled = $(window).scrollTop()
            const header_h = $('.jky-header').height()
            const header_h_aftersales = $('.header-after-sales').height() || 0
            if(window.innerWidth < 1024 && $(".shopify-section.jky-header").hasClass(".menu-active--open")) return
            if(target_top - scrolled <= header_h) {
                $('.jky-header').css("top", (target_top - scrolled - header_h - header_h_aftersales) + 'px')
                $(".cal_scroll_target").addClass('sticky_anchor_active')
            } else {
                $('.jky-header').css("top", '0px')
                $(".cal_scroll_target").removeClass('sticky_anchor_active')
            }
        } else {
            const target_top = $(".cal_scroll_target").offset().top
            var scrolled = $(window).scrollTop()
            const header_h = $('.site-header').height()
            const header_h_aftersales = $('.header-after-sales').height() || 0

            if(target_top - scrolled <= header_h) {
                $('.site-header').css("top", (target_top - scrolled - header_h - header_h_aftersales) + 'px')
                $(".cal_scroll_target").addClass('sticky_anchor_active')
            } else {
                $('.site-header').css("top", '0px')
                $(".cal_scroll_target").removeClass('sticky_anchor_active')
            }
        }
    });

    if(document.querySelector("header.site-header")) {
        const resizeObserver = new ResizeObserver((entries) => {
            const {height} = entries[0].contentRect;
            $('body').css('--jky-header-h', height + 'px')
          }
        );
        // 监听jky-header高度变化
        resizeObserver.observe(document.querySelector("header.site-header"));
    }

    // 获取 url 的 discount_code，并存储到 cookie
    // 这样跳转 checkout 页，可以自动适用折扣码
    const searchParams = window.location.search
    const decodeParams = decodeURIComponent(searchParams)
    const urlParams = new URLSearchParams(decodeParams)
    const discountCode = urlParams.get('discount_code')
    if (discountCode) {
        let d = new Date()
        d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000)) // 7天
        document.cookie = `discount_code=${discountCode};expires=${d.toGMTString()};path=/`
    }
})
// TODO: 待迁移整理：全局函数处理
